import React from 'react'
import PropTypes from 'prop-types'
import {
    Box,
    Stack,
    Flex,
    Text,
    Button,
    Image,
    HStack,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import DeleteIcon from '../../../components/icons/action/DeleteIcon'
import {useProduct} from '@salesforce/commerce-sdk-react'
import {useCurrency} from '@salesforce/retail-react-app/app/hooks'

const formatDate = (dateInput) => {
    // Check if the input is already a Date object
    let date
    if (dateInput instanceof Date) {
        date = dateInput
    } else {
        // If it's a string, parse it as a date
        const isNoSeparatorFormat = /^\d{14}$/.test(dateInput)
        if (isNoSeparatorFormat) {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
            const [_, year, month, day] = dateInput.match(/(\d{4})(\d{2})(\d{2})/).map(Number)
            date = new Date(year, month - 1, day) // month is 0-based
        } else {
            date = new Date(dateInput)
        }
    }

    return date.toLocaleDateString('it-IT')
}

const RegisteredProductItem = ({
    product,
    styles,
    onEditClick,
    onDeleteClick,
    onCustomerSupportClick,
    onFAQsClick,
}) => {
    const {currency: activeCurrency} = useCurrency()
    const {data: productData} = useProduct({
        parameters: {
            id: product.skuKut,
            allImages: false,
            currency: activeCurrency,
        },
    })
    const smallImage = productData?.imageGroups?.find((item) => item.viewType === 'medium')
        ?.images[0]?.link

    return (
        <Box {...styles.registeredProductBox}>
            <Stack data-testid={`registered-product-${product.productid}`}>
                <Flex gap={6}>
                    <Image
                        {...styles.registeredProductImage}
                        src={smallImage}
                        alt={product?.c_variantIdentifier}
                    />
                    <Stack spacing={10} w="100%">
                        <Flex flexDir={'column'} gap={4} position={'relative'}>
                            <HStack {...styles.registredProductNameContainer}>
                                <Text {...styles.registeredProductName}>{productData?.name}</Text>
                                <Button
                                    onClick={() => onDeleteClick(product)}
                                    data-testid="cart-item-remove-button"
                                >
                                    <DeleteIcon {...styles.registeredProductDeleteIcon} />
                                </Button>
                            </HStack>
                            <Stack>
                                <Text {...styles.registeredProductPurchased}>
                                    <strong>Purchased on:</strong>
                                    {product.purchaseData
                                        ? formatDate(product.purchaseData)
                                        : formatDate(product.referenceDate)}
                                </Text>
                                <Text {...styles.registeredProductRegistration}>
                                    <strong>Registered on:</strong>
                                    {formatDate(product.registrationDateKut)}
                                </Text>
                            </Stack>
                            <Button
                                {...styles.editRegisterProduct}
                                variant="text-button"
                                onClick={() => onEditClick(product)}
                            >
                                Modifica
                            </Button>
                        </Flex>
                        <Flex
                            gap={4}
                            flexDirection={{
                                base: 'column',
                                md: 'row',
                            }}
                        >
                            <Button
                                {...styles.serviceButton}
                                variant="secondary"
                                onClick={onCustomerSupportClick}
                            >
                                Customer Support
                            </Button>
                            <Button
                                {...styles.serviceButton}
                                variant="secondary"
                                onClick={onFAQsClick}
                            >
                                FAQs
                            </Button>
                        </Flex>
                    </Stack>
                </Flex>
            </Stack>
        </Box>
    )
}

RegisteredProductItem.propTypes = {
    product: PropTypes.object.isRequired,
    styles: PropTypes.object.isRequired,
    onEditClick: PropTypes.func.isRequired,
    onDeleteClick: PropTypes.func.isRequired,
    onCustomerSupportClick: PropTypes.func.isRequired,
    onFAQsClick: PropTypes.func.isRequired,
}

export default RegisteredProductItem
export {formatDate}
